import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12","key":"svg-0"}],["path",{"d":"M19 16h-12a2 2 0 0 0 -2 2","key":"svg-1"}],["path",{"d":"M9 8h6","key":"svg-2"}]]

const IconBook2 = createReactComponent('outline', 'book-2', 'Book2', __iconNode);

export default IconBook2;